import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

const
    DEFAULT_NUM_RESULTS = 5,
    name = 'topByProductArea',
    exports = storeModuleFactory({
        name,
        endpoint:        endpoints.topByConcept.endpoint,
        timeout:         TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        parseParameters: parameters => ({
            start_date: Math.floor(parameters.startDate / TIMESTAMP_MULTIPLY),
            end_date:   Math.floor(parameters.endDate / TIMESTAMP_MULTIPLY)
        }),
        transformEntitiesFn: item => ({
            id:    item.entity.code,
            name:  item.entity.title,
            value: item.amount
        }),
        defaultParameters: {
            by:        'product_area',
            page_size: DEFAULT_NUM_RESULTS
        }
    });


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/topByProductArea.js